<template>
  <div class="swiperComponent" :class="{ 'mt-3': viewportWidth <= 640 }">
    <swiper
      :options="swiperOptionTop"
      class="gallery-top"
      ref="swiperTop"
      v-if="productAlbum.length > 0"
    >
      <!-- slides -->
      <swiper-slide
        class="bigImg"
        v-for="item in productAlbum"
        :key="item.albumId"
      >
          <!-- <div class="discount" v-if="categoryId === 2 || categoryId === 6">
            <img :src="discountInfo.decorationImg" :alt="discountInfo.menuDecorationText">
        </div> -->
        <!-- <div class="magnifying d-flex justify-content-center align-content-center">&#x1F50E;&#xFE0E;</div> -->
        <!-- <image-zoom
          regular="https://fakeimg.pl/600x600/"
          lazyload=true
          img-class="img-fluid"
          hover-message="&#x1F50E;&#xFE0E;">
        </image-zoom> -->
        <!-- <img src="https://fakeimg.pl/600x600/" alt="" /> -->
        <!-- <img
          :src="$store.state.imgPath + item.docorationImg"
          :alt="item.productId"
        /> -->
        <image-zoom
          :regular="$store.state.imgPath + item.productAlbum"
          alt=""
          :lazyload="true"
          img-class="img-fluid"
          hover-message="&#x1F50E;&#xFE0E;">
        </image-zoom>
        <!--

        </image-zoom>
          <img
          :src="$store.state.imgPath + item.productAlbum"
          :alt="item.albumId"
        /> -->
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <swiper
      :options="swiperOptionThumbs"
      class="gallery-thumbs mt-3"
      ref="swiperThumbs"
      v-if="viewportWidth > 640 && productAlbum.length > 0"
    >
      <swiper-slide
        class="slide-1 smallImg"
        v-for="item in productAlbum"
        :key="item.albumId"
        ><img :src="$store.state.imgPath + item.productAlbum" alt=""
      /></swiper-slide>
    </swiper>
    <swiper
      :options="swiperOptionThumbs"
      class="gallery-thumbs mt-3"
      ref="swiperThumbs"
      v-if="viewportWidth < 640 && productAlbum.length > 0"
    >
      <swiper-slide
        class="slide-1 smallImg"
        v-for="item in productAlbum"
        :key="item.albumId"
        ><img :src="$store.state.imgPath + item.productAlbum" alt=""
      /></swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'
export default {
  props: ['viewportWidth'],
  name: 'carrousel',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      text: {
        hoverMessage: `<i class="fa-solid fa-magnifying-glass"></i>`
      },
      swiperOptionTop: {
        spaceBetween: 10,
        slidesPerView: 1,
        loopedSlides: null, // looped slides should be the same
        effect: 'fade',
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        updateOnWindowResize: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        touchRatio: 0.2,
        slidesPerView: 'auto',
        loopedSlides: null, // looped slides should be the same
        slideToClickedSlide: true,
        centeredSlides: true,
        loop: true
      },
      // 放左邊相片資訊
      productAlbum: []
    }
  },
  // 處理v-for swiper 跟資料不同步問題
  async created () {
    const id = this.$route.params.id
    let API_PATH = process.env.API
    await this.$http
      .get(`${API_PATH}product/getdetail/${id}`)
      .then((response) => {
        if (response.data.data.productAlbum.length === 0) {
          let productAlbum = {
            productAlbum: 'https://fakeimg.pl/599/?text=fake image'
          }
          this.productAlbum.push(productAlbum)
        } else {
          this.productAlbum = response.data.data.productAlbum
        }
        this.swiperOptionTop.loopedSlides = this.productAlbum.length
        this.swiperOptionThumbs.loopedSlides = this.productAlbum.length
        this.$nextTick(() => {
          const swiperTop = this.$refs.swiperTop.swiper
          const swiperThumbs = this.$refs.swiperThumbs.swiper
          swiperTop.controller.control = swiperThumbs
          swiperThumbs.controller.control = swiperTop
        })
      })
  },
  watch: {
    async $route (to, from) {
      if (to.params.id !== from.params.id) {
        const id = to.params.id
        let API_PATH = process.env.API
        this.productAlbum = []
        await this.$http
          .get(`${API_PATH}product/getdetail/${id}`)
          .then((response) => {
            if (response.data.data.productAlbum.length === 0) {
              let productAlbum = {
                productAlbum: 'https://fakeimg.pl/599/?text=fake image'
              }
              this.productAlbum.push(productAlbum)
            } else {
              this.productAlbum = response.data.data.productAlbum
            }
            this.swiperOptionTop.loopedSlides = this.productAlbum.length
            this.swiperOptionThumbs.loopedSlides = this.productAlbum.length
            this.$nextTick(() => {
              const swiperTop = this.$refs.swiperTop.swiper
              const swiperThumbs = this.$refs.swiperThumbs.swiper
              swiperTop.controller.control = swiperThumbs
              swiperThumbs.controller.control = swiperTop
            })
          })
      }
    }
  },
  computed: {
    // 從Vuex取出資料
    ...mapState({
      productId: (state) => state.standardModules.productId,
      categoryId: (state) => state.standardModules.categoryId,
      // discount
      discountInfo: (state) => state.navbarModules.discountInfo
    })
  }
}
</script>

<style lang="scss" scoped>
.swiper-container {
  background-color: rgba(92, 135, 166, 0.2);
}
.swiper-container {
  height: auto;
  max-width: 600px;
  &.gallery-thumbs {
    max-width: 600px;
  }
}
.swiper-slide {
  max-width: 600px;
  height: auto;
  img {
    width: 100%;
    height: auto;
  }
}
.smallImg {
  max-width: 73px;
  height: auto;
}
@media (max-width: 640px) {
  .gallery-thumbs {
    height: 0;
  }
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
  // 輪到的時候標明顯一點
  &.swiper-slide-active {
    opacity: 1;
  }
}
.bigImg {
  position: relative;
}
.product {
  position: absolute;
  z-index: 1;
}
.discount {
  position: absolute;
  z-index: 2;
  width: 200px;
  height: 200px;
}
.magnifying{
  position:absolute;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.4);
  left: 50;
  font-size: 1.5rem;
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

@media(max-width: 1140px) {
  .discount {
    width: 100px;
    height: 100px;
  }
}

@media(max-width: 641px) {
  .discount {
    width: 100px;
    height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiperComponent.vue